module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images && _vm.images.length) ? _c('div', {
    staticClass: "client-item-box new-image",
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "new-image-box"
  }, [_c('div', {
    staticClass: "new-image-items",
    style: ({
      height: (_vm.maxHeight + "px")
    })
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "img-box",
      style: ({
        width: ((item.widthNum) + "px"),
        height: (_vm.maxHeight + "px"),
        left: ("" + (item.left))
      })
    }, [_c('div', {
      staticClass: "img-item",
      class: _vm.videowrap(index),
      style: ({
        width: ((item.widthNum) + "px"),
        height: ((item.heightNum) + "px"),
        borderRadius: ("" + _vm.radius)
      }),
      on: {
        "click": function($event) {
          return _vm.mediaAction(item, index)
        }
      }
    }, [(item.type === 'image') ? _c('beast-image', {
      staticClass: "img",
      attrs: {
        "lazy": true,
        "image": item.image,
        "containerWidth": item.widthNum
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'video') ? _c('beast-video', {
      attrs: {
        "wrap": item.wrapIndex,
        "height": item.heightNum,
        "poster": item.poster,
        "autoplay": item.autoplay,
        "source": item.source,
        "controls": item.controls,
        "videoFormat": item.videoFormat,
        "muted": item.muted,
        "radius": _vm.radius,
        "multiVideo": _vm.multiVideo,
        "videoPopData": item
      },
      on: {
        "video-pop": _vm.videoPopAction
      }
    }) : _vm._e()], 1)])
  }), 0)]), _vm._v(" "), (_vm.videoPopFlag) ? _c('video-pop', {
    attrs: {
      "data": _vm.videoPopData,
      "radius": _vm.radius
    },
    on: {
      "close": _vm.closeAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dba952f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/new-image.vue
// module id = 643
// module chunks = 1 13